namespace GeniuzPOS.CustomReport {
    export interface ReportCusSaleComparisonForm {
    }

    export class ReportCusSaleComparisonForm extends Serenity.PrefixedContext {
        static formKey = 'CustomReport.ReportCusSaleComparison';
    }
}
